import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { AdminOrderItemProductAttributeResponse } from './admin-order-item-product-attribute.response';

@jsonObject
export class AdminOrderItemAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(AdminOrderItemProductAttributeResponse)
  public readonly productAttribute!: AdminOrderItemProductAttributeResponse;
}
